import React, { useState } from 'react';
import { Card, Row, Col, Input, Checkbox, Button, Space } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import './SearchBar.css';

interface SearchBarProps {
  onSearch: (filters: { keyword: string; country: string; city: string; state: string; recruitingOnly: boolean }) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [keyword, setKeyword] = useState('');
  const [country, setCountry] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [recruitingOnly, setRecruitingOnly] = useState(true);

  const handleSearch = () => {
    onSearch({ 
      keyword: keyword.trim(), 
      country: country.trim(), 
      city: city.trim(),
      state: state.trim(),
      recruitingOnly 
    });
  };

  const handleReset = () => {
    setKeyword('');
    setCountry('');
    setCity('');
    setState('');
    setRecruitingOnly(true);
    onSearch({ keyword: '', country: '', city: '', state: '', recruitingOnly: true });
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Card className="search-bar" style={{ marginBottom: '24px' }}>
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={8} md={6}>
          <div>
            <div style={{ marginBottom: '4px', fontWeight: 500 }}>职位关键词</div>
            <Input
              placeholder="如：产品经理、前端开发..."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onPressEnter={handleKeyPress}
              allowClear
            />
          </div>
        </Col>
        
        <Col xs={24} sm={8} md={4}>
          <div>
            <div style={{ marginBottom: '4px', fontWeight: 500 }}>国家</div>
            <Input
              placeholder="如：中国、美国..."
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              onPressEnter={handleKeyPress}
              allowClear
            />
          </div>
        </Col>

        <Col xs={24} sm={8} md={4}>
          <div>
            <div style={{ marginBottom: '4px', fontWeight: 500 }}>城市</div>
            <Input
              placeholder="如：上海市、北京市..."
              value={city}
              onChange={(e) => setCity(e.target.value)}
              onPressEnter={handleKeyPress}
              allowClear
            />
          </div>
        </Col>

        <Col xs={24} sm={8} md={4}>
          <div>
            <div style={{ marginBottom: '4px', fontWeight: 500 }}>州/省</div>
            <Input
              placeholder="如：广东省、加州..."
              value={state}
              onChange={(e) => setState(e.target.value)}
              onPressEnter={handleKeyPress}
              allowClear
            />
          </div>
        </Col>

        <Col xs={24} sm={12} md={4}>
          <div style={{ paddingTop: '24px' }}>
            <Checkbox
              checked={recruitingOnly}
              onChange={(e) => setRecruitingOnly(e.target.checked)}
            >
              仅显示招聘中的岗位
            </Checkbox>
          </div>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <div style={{ paddingTop: '24px' }}>
            <Space>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                搜索岗位
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={handleReset}
              >
                重置
              </Button>
            </Space>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default SearchBar;
